import React, { FC, useMemo, useState } from 'react'

import { TableSortType } from 'src/components/molecules'
import { AssignProjectListItem } from 'src/components/organisms'
import {
  AssignProjectListHead,
  AssignProjectSortItemType,
} from 'src/components/organisms/projects/AssignProjectListHead'

import { AssignedProjectEntity } from 'src/types'

type Props = {
  projects: AssignedProjectEntity[]
  onClickRow: (project: AssignedProjectEntity) => void
  className?: string
}

export const AssignProjectList: FC<Props> = ({ projects, onClickRow, className }) => {
  const [sortItem, setSortItem] = useState<AssignProjectSortItemType>('status')
  const [sortType, setSortType] = useState<TableSortType>('asc')

  const sortedProjects = useMemo(() => {
    const order = sortType === 'desc' ? 1 : -1

    if (sortItem === 'project') {
      return [...projects].sort((a, b) => {
        return (a.name ?? '-') < (b.name ?? '-') ? order : -order
      })
    }

    if (sortItem === 'status') {
      return [...projects].sort((a, b) => {
        // 削除中の場合は必ず最後に持ってくる
        if (a.isDeleting && !b.isDeleting) {
          return 1
        }
        if (!a.isDeleting && b.isDeleting) {
          return -1
        }
        return a.status.priority < b.status.priority ? order : -order
      })
    }

    if (sortItem === 'role') {
      return [...projects].sort((a, b) => {
        return a.compassRole.priority < b.compassRole.priority ? order : -order
      })
    }

    return projects
  }, [projects, sortItem, sortType])

  const handleSelectSortItem = (newItem: AssignProjectSortItemType) => {
    if (sortItem === newItem) {
      const newSortType = sortType === 'desc' ? 'asc' : 'desc'
      setSortType(newSortType)
      return
    }
    setSortItem(newItem)
    setSortType('asc')
  }

  return (
    <div className={className}>
      <AssignProjectListHead
        sortItem={sortItem}
        sortType={sortType}
        onSelectItem={handleSelectSortItem}
        className="tw-w-full"
      />
      <ul>
        {sortedProjects.map(project => (
          <li
            role="presentation"
            key={project.id}
            className={`tw-border-t tw-border-border-secondary first:tw-border-none tw-bg-surface-primary ${
              project.isDeleting ? '' : 'hover:tw-bg-surface-secondary tw-cursor-pointer'
            }`}
            onClick={() => !project.isDeleting && onClickRow(project)}
          >
            <AssignProjectListItem project={project} />
          </li>
        ))}
      </ul>
    </div>
  )
}
